module.exports = __webpack_public_path__ + "img/train-platform.b3d2e0be.png";